import React, { useEffect, useRef, useState } from 'react';

import { useNavigate, useSearchParams } from 'react-router-dom';

import { useFinishSalesforceConnectMutation } from '../api/salesforce';

// Salesforce sends the admin back here (via /api/salesforce/callback). The signed-in
// admin who started the connect posts the code; the backend checks it is theirs.
const SalesforceCallbackPage: React.FC = () => {
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const [finishConnect] = useFinishSalesforceConnectMutation();
	const started = useRef(false);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		if (started.current) return;
		started.current = true;
		const code = searchParams.get('code');
		const state = searchParams.get('state');
		if (!code || !state) {
			setError(searchParams.get('error') ?? 'Salesforce did not send a code.');
			return;
		}
		finishConnect({ code, state })
			.unwrap()
			.then(() => navigate('/settings?salesforce=connected', { replace: true }))
			.catch((err: { data?: { message?: string } }) =>
				setError(err.data?.message ?? 'Could not connect Salesforce.'),
			);
	}, [finishConnect, navigate, searchParams]);

	return (
		<div className="p-8 text-sm">
			{error ? (
				<p role="alert" className="text-red-600">
					{error}
				</p>
			) : (
				<p>Connecting Salesforce…</p>
			)}
		</div>
	);
};

export default SalesforceCallbackPage;
